/* ============================================================================
   PATTAN AUSTRALIA — theme JavaScript
   Native browser APIs only. No jQuery, no framework, no external libraries.
   Replaces a baseline of 71 script tags / 21 external scripts.
   Everything degrades gracefully: with JS off, links and forms still work.
   ========================================================================= */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* --- DRAWERS (menu, cart, filters) ------------------------------------ */
  var overlay = $('[data-overlay]');
  var openDrawer = null;
  var lastFocus = null;

  function drawerOpen(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); }); }
    document.body.style.overflow = 'hidden';
    openDrawer = d;
    var focusable = d.querySelector('button, a, input, select');
    if (focusable) focusable.focus();
  }

  function drawerClose() {
    if (!openDrawer) return;
    var d = openDrawer;
    d.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { d.hidden = true; if (overlay) overlay.hidden = true; }, 220);
    openDrawer = null;
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); drawerOpen(opener.getAttribute('data-open-drawer')); return; }
    if (e.target.closest('[data-close-drawer]') || e.target === overlay) { drawerClose(); }
  });

  // Escape closes any drawer — basic accessibility the old theme lacked.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) drawerClose();
  });

  /* --- MOBILE MENU: drill-down panels ------------------------------------ */
  document.addEventListener('click', function (e) {
    var into = e.target.closest('[data-drawer-into]');
    if (into) {
      var i = into.getAttribute('data-drawer-into');
      var root = into.closest('.drawer');
      $('[data-drawer-panel]', root).hidden = true;
      var sub = $('[data-drawer-sub="' + i + '"]', root);
      if (sub) { sub.hidden = false; var f = sub.querySelector('a,button'); if (f) f.focus(); }
      return;
    }
    var back = e.target.closest('[data-drawer-back]');
    if (back) {
      var r = back.closest('.drawer');
      $$('[data-drawer-sub]', r).forEach(function (p) { p.hidden = true; });
      $('[data-drawer-panel]', r).hidden = false;
    }
  });

  /* --- PDP GALLERY -------------------------------------------------------- */
  var mainImg = $('[data-gallery-image]');
  if (mainImg) {
    $$('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImg.src = btn.getAttribute('data-gallery-thumb');
        mainImg.removeAttribute('srcset');
        $$('[data-gallery-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  /* --- QUANTITY ----------------------------------------------------------- */
  $$('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = $('[data-qty-input]', btn.closest('.qty'));
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, btn.getAttribute('data-qty') === '+' ? v + 1 : v - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* --- VARIANT SELECTION -------------------------------------------------- */
  var variantSelect = $('[data-variant-select]');
  if (variantSelect) {
    var groups = $$('.variant-options');
    function currentSelection() {
      return groups.map(function (g) {
        var sel = g.querySelector('[aria-checked="true"]');
        return sel ? sel.getAttribute('data-option-value') : null;
      });
    }
    function syncVariant() {
      var wanted = currentSelection().filter(Boolean).join(' / ');
      var opts = Array.prototype.slice.call(variantSelect.options);
      var match = opts.filter(function (o) { return o.textContent.trim() === wanted; })[0];
      if (match) {
        variantSelect.value = match.value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        var stock = $('[data-stock]');
        if (stock) {
          var avail = !match.disabled;
          stock.classList.toggle('stock--in', avail);
          stock.classList.toggle('stock--out', !avail);
          stock.lastChild.textContent = avail ? ' In stock' : ' Currently unavailable';
        }
      }
    }
    $$('.variant-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.variant-options');
        $$('.variant-option', group).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        syncVariant();
      });
      // Keyboard support for the radiogroup pattern.
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var sibs = $$('.variant-option', btn.closest('.variant-options'));
        var i = sibs.indexOf(btn);
        var next = sibs[e.key === 'ArrowRight' ? (i + 1) % sibs.length : (i - 1 + sibs.length) % sibs.length];
        next.focus(); next.click();
      });
    });
  }

  /* --- STICKY ADD TO CART (mobile) ---------------------------------------
     Appears only after the real Add to Cart scrolls out of view, so it never
     competes with the primary button or wastes viewport height. */
  var sticky = $('[data-sticky-atc]');
  var realForm = $('#product-form');
  if (sticky && realForm && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' });
    io.observe(realForm);
    var stickyBtn = $('[data-sticky-add]', sticky);
    if (stickyBtn) stickyBtn.addEventListener('click', function () { realForm.requestSubmit ? realForm.requestSubmit() : realForm.submit(); });
  }

  /* --- COLLECTION FILTERS + SORT -----------------------------------------
     Progressive enhancement: forms submit normally without JS. */
  function applyParams(form) {
    var params = new URLSearchParams(window.location.search);
    ['sort_by'].forEach(function (k) { params.delete(k); });
    new FormData(form).forEach(function (v, k) { if (v) params.append(k, v); });
    window.location.search = params.toString();
  }
  $$('[data-sort-form] select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sel.value);
      window.location.search = params.toString();
    });
  });
  var facetForm = $('[data-facet-form]');
  if (facetForm) {
    var t;
    facetForm.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var params = new URLSearchParams();
        new FormData(facetForm).forEach(function (v, k) { if (v) params.append(k, v); });
        var sort = new URLSearchParams(window.location.search).get('sort_by');
        if (sort) params.set('sort_by', sort);
        window.location.search = params.toString();
      }, 250);
    });
  }

  /* --- PREDICTIVE SEARCH --------------------------------------------------
     Uses Shopify's native /search/suggest endpoint. No paid search app needed
     at 3,025 products. */
  var searchInput = $('[data-predictive-input]');
  var searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    var st, controller;
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(st);
      if (q.length < 2) { searchResults.hidden = true; searchResults.innerHTML = ''; return; }
      st = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search',
              { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) { searchResults.innerHTML = html; searchResults.hidden = false; })
          .catch(function () { /* aborted or offline — stay silent */ });
      }, 200);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.search')) searchResults.hidden = true;
    });
  }

  /* --- RECENTLY VIEWED ----------------------------------------------------
     localStorage only. No cookies, no tracking, no network cost. */
  try {
    var KEY = 'pattan_recent';
    var handle = document.body.className.indexOf('template-product') > -1
      ? window.location.pathname.split('/products/')[1] : null;
    if (handle) {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]').filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    }
  } catch (e) { /* private browsing — ignore */ }
})();

/* ============================================================================
   SECOND-PASS FIXES — issues found reviewing the first implementation.
   ========================================================================= */
(function () {
  'use strict';
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* FIX: the mega menu opened on hover only, so keyboard users could never
     reach it. Toggle on click/Enter as well, and close on Escape. */
  $$('.nav__link[aria-haspopup="true"]').forEach(function (link) {
    var item = link.closest('.nav__item');
    var mega = $('.mega', item);
    if (!mega) return;
    link.addEventListener('click', function (e) {
      var open = link.getAttribute('aria-expanded') === 'true';
      e.preventDefault();
      $$('.nav__link[aria-haspopup="true"]').forEach(function (l) {
        l.setAttribute('aria-expanded', 'false');
        var m = $('.mega', l.closest('.nav__item')); if (m) m.removeAttribute('data-open');
      });
      if (!open) { link.setAttribute('aria-expanded', 'true'); mega.setAttribute('data-open', 'true'); }
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        link.setAttribute('aria-expanded', 'false');
        mega.removeAttribute('data-open');
        link.focus();
      }
    });
  });
  // Clicking outside closes any open mega menu.
  document.addEventListener('click', function (e) {
    if (e.target.closest('.nav__item')) return;
    $$('.nav__link[aria-haspopup="true"]').forEach(function (l) {
      l.setAttribute('aria-expanded', 'false');
      var m = $('.mega', l.closest('.nav__item')); if (m) m.removeAttribute('data-open');
    });
  });

  /* FIX: quantity inputs accepted 0, negatives and pasted text. */
  $$('[data-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = 1;
    });
  });

  /* FIX: predictive search had no keyboard navigation — mouse only. */
  var searchInput = $('[data-predictive-input]');
  var results = $('[data-predictive-results]');
  if (searchInput && results) {
    searchInput.setAttribute('enterkeyhint', 'search');
    searchInput.addEventListener('keydown', function (e) {
      if (results.hidden) return;
      var rows = $$('.ps__row, .ps__all', results);
      if (!rows.length) return;
      var i = rows.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (rows[i + 1] || rows[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (rows[i - 1] || rows[rows.length - 1]).focus(); }
      else if (e.key === 'Escape') { results.hidden = true; searchInput.focus(); }
    });
    results.addEventListener('keydown', function (e) {
      var rows = $$('.ps__row, .ps__all', results);
      var i = rows.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (rows[i + 1] || rows[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); i <= 0 ? searchInput.focus() : rows[i - 1].focus(); }
      else if (e.key === 'Escape') { results.hidden = true; searchInput.focus(); }
    });
  }

  /* FIX: the sticky mobile bar submitted the form but ignored the quantity
     the customer had chosen. */
  var stickyBtn = $('[data-sticky-add]');
  var qtyInput = $('[data-qty-input]');
  if (stickyBtn && qtyInput) {
    stickyBtn.addEventListener('click', function () {
      if (parseInt(qtyInput.value, 10) < 1) qtyInput.value = 1;
    }, true);
  }
})();

/* Collection SEO intro: clamp with a Read more toggle (pattern from The Good Guys,
   which truncates category copy rather than pushing products down the page). */
(function () {
  var el = document.querySelector('[data-clamp]');
  var btn = document.querySelector('[data-clamp-toggle]');
  if (!el || !btn) return;
  if (el.scrollHeight <= el.clientHeight + 4) return;  // short copy: no toggle needed
  btn.hidden = false;
  btn.addEventListener('click', function () {
    var open = el.classList.toggle('collection__intro--clamped');
    btn.textContent = open ? 'Read more' : 'Read less';
  });
})();

/* ============================================================================
   RECENTLY VIEWED + PRODUCT RECOMMENDATIONS
   Both fetch real Shopify markup. Neither invents or randomises products.
   ========================================================================= */
(function () {
  'use strict';

  /* Recently viewed — reads handles written on each PDP visit, then fetches each
     product's card markup. Hidden entirely on a first visit. */
  var rvSection = document.querySelector('[data-recently-viewed]');
  var rvGrid = document.querySelector('[data-recently-viewed-grid]');
  if (rvSection && rvGrid) {
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('pattan_recent') || '[]'); } catch (e) {}
    // Don't show the product you're already looking at.
    var current = window.location.pathname.split('/products/')[1];
    handles = handles.filter(function (h) { return h && h !== current; }).slice(0, 5);
    if (handles.length) {
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '?view=card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (parts) {
        var good = parts.filter(function (p) { return p && p.trim(); });
        // A "Recently viewed" row holding one card reads as a broken section rather than a
        // utility. Below the minimum, stay hidden.
        var min = parseInt(rvSection.getAttribute('data-recently-min') || '1', 10);
        if (good.length >= min) { rvGrid.innerHTML = good.join(''); rvSection.hidden = false; }
      });
    }
  }

  /* Product recommendations — Shopify's native endpoint. When intent is
     "complementary" these are merchant-curated in Search & Discovery, so they are
     genuinely related rather than algorithmic filler. */
  /* The product page has TWO of these — "Goes well with" (complementary) and
     "You may also like" (related). querySelector only ever hydrated the first,
     so the second sat empty forever. Hydrate every one. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-recommendations]'), function (recGrid) {
    if (!recGrid.dataset.url || recGrid.children.length) return;
    var hide = function () {
      var sec = recGrid.closest('[data-related]');
      if (sec) sec.hidden = true;   // nothing to show: hide rather than show an empty heading
    };
    fetch(recGrid.dataset.url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (!text) return hide();
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var inner = doc.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) recGrid.innerHTML = inner.innerHTML;
        else hide();
      })
      .catch(hide);
  });
})();

/* ==========================================================================
   LIVE CART — add to cart, quantity, delivery protection, upsell
   The drawer is a SECTION, so every mutation re-renders it server-side via the
   Section Rendering API. That keeps the multibuy progress, the applied discount
   and the totals honest: they are always Shopify's numbers, never recomputed
   in the browser where they could drift from what checkout actually charges.
   ====================================================================== */
(function () {
  var SECTION = 'cart-drawer';

  function drawerEl() { return document.querySelector('[data-drawer="cart"]'); }

  function swap(html) {
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer="cart"]');
    var current = drawerEl();
    if (!fresh || !current) return;
    var wasOpen = current.classList.contains('is-open');
    fresh.hidden = current.hidden;
    if (wasOpen) fresh.classList.add('is-open');
    current.replaceWith(fresh);
    loadUpsell();
  }

  function refresh() {
    return fetch('/?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(function (j) { swap(j[SECTION]); })
      .catch(function () {});
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function post(url, body) {
    body.sections = SECTION;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function afterMutation(json) {
    if (json && json.sections && json.sections[SECTION]) swap(json.sections[SECTION]);
    else refresh();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
  }

  /* --- add to cart ------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var fd = new FormData(form);
    var body = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) }], sections: SECTION };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status && json.status !== 200) throw new Error(json.description || json.message);
        afterMutation(json);
        var opener = document.querySelector('[data-open-drawer="cart"]');
        if (opener) opener.click();
      })
      .catch(function (err) {
        // Never fail silently — the customer must know the item did not go in.
        var msg = form.querySelector('[data-atc-error]');
        if (!msg) { msg = document.createElement('p'); msg.setAttribute('data-atc-error', ''); msg.className = 'atc-error'; form.appendChild(msg); }
        msg.textContent = (err && err.message) ? err.message : 'Sorry, that could not be added to your cart.';
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* --- quantity + remove ------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    var rm = e.target.closest('[data-qty-remove]');
    if (!up && !down && !rm) return;
    e.preventDefault();
    var btn = up || down || rm;
    var key = btn.getAttribute('data-key');
    var row = btn.closest('.cart-item');
    var current = row ? parseInt(row.querySelector('.qty__n').textContent, 10) : 1;
    var qty = rm ? 0 : (up ? current + 1 : Math.max(0, current - 1));
    post('/cart/change.js', { id: key, quantity: qty }).then(afterMutation);
  });

  /* --- delivery protection --------------------------------------------- */
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-protection]');
    if (!box) return;
    var vid = box.getAttribute('data-variant');
    if (box.checked) {
      post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] }).then(afterMutation);
    } else {
      // find its line key from the live cart, then zero it
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var line = c.items.filter(function (i) { return String(i.variant_id) === String(vid); })[0];
        if (!line) return;
        post('/cart/change.js', { id: line.key, quantity: 0 }).then(afterMutation);
      });
    }
  });

  /* --- cart upsell ------------------------------------------------------ */
  function loadUpsell() {
    var host = document.querySelector('[data-cart-upsell]');
    if (!host) return;
    var list = host.querySelector('[data-cart-upsell-list]');
    if (!list || list.children.length) return;
    fetch(host.dataset.url + '&section_id=cart-upsell')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (!text) { host.hidden = true; return; }
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var items = doc.querySelectorAll('[data-upsell-item]');
        if (!items.length) { host.hidden = true; return; }
        items.forEach(function (n) { list.appendChild(n); });
      })
      .catch(function () { host.hidden = true; });
  }

  loadUpsell();
})();

/* ==========================================================================
   MEGA MENU
   The previous implementation was hover-only via CSS, with aria-expanded
   hardcoded to "false" — so it was unreachable by keyboard and lied to screen
   readers. This drives real state: pointer with an intent delay (so brushing
   past a link does not flash a full-width panel), click to pin, Escape and
   focus-out to close, and arrow keys along the bar.
   ====================================================================== */
(function () {
  var nav = document.querySelector('.nav');
  if (!nav) return;

  var triggers = Array.prototype.slice.call(nav.querySelectorAll('[data-mega-trigger]'));
  if (!triggers.length) return;

  var openId = null, hoverTimer = null, closeTimer = null;
  var HOVER_IN = 120, HOVER_OUT = 220;

  function panelFor(id) { return nav.querySelector('[data-mega="' + id + '"]'); }

  function close(id) {
    var p = panelFor(id); if (!p) return;
    p.hidden = true;
    var tr = nav.querySelector('[data-mega-trigger="' + id + '"]');
    if (tr) tr.setAttribute('aria-expanded', 'false');
    if (openId === id) openId = null;
  }

  function closeAll() { triggers.forEach(function (t) { close(t.getAttribute('data-mega-trigger')); }); }

  function open(id) {
    if (openId === id) return;
    closeAll();
    var p = panelFor(id); if (!p) return;
    p.hidden = false;
    var tr = nav.querySelector('[data-mega-trigger="' + id + '"]');
    if (tr) tr.setAttribute('aria-expanded', 'true');
    openId = id;
  }

  triggers.forEach(function (tr) {
    var id = tr.getAttribute('data-mega-trigger');
    var item = tr.closest('.nav__item');

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer); clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { open(id); }, HOVER_IN);
    });
    item.addEventListener('mouseleave', function () {
      clearTimeout(hoverTimer);
      closeTimer = setTimeout(function () { close(id); }, HOVER_OUT);
    });

    // Click pins the panel open instead of following the link, so the category
    // page is still reachable on the second click or via "Shop all".
    tr.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches) return;   // touch: let the link work
      if (openId !== id) { e.preventDefault(); open(id); }
    });

    tr.addEventListener('keydown', function (e) {
      var i = triggers.indexOf(tr);
      if (e.key === 'ArrowDown' || (e.key === 'Enter' && openId !== id)) {
        e.preventDefault(); open(id);
        var first = panelFor(id).querySelector('a'); if (first) first.focus();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault(); triggers[(i + 1) % triggers.length].focus();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault(); triggers[(i - 1 + triggers.length) % triggers.length].focus();
      }
    });
  });

  nav.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openId) return;
    var tr = nav.querySelector('[data-mega-trigger="' + openId + '"]');
    close(openId);
    if (tr) tr.focus();
  });

  // Tabbing out of the whole nav closes it.
  nav.addEventListener('focusout', function (e) {
    if (!nav.contains(e.relatedTarget)) closeAll();
  });

  document.addEventListener('click', function (e) { if (!nav.contains(e.target)) closeAll(); });
})();
